import React from 'react';
import { notification, Modal, LoadingTip } from 'tea-component';

function timePromise(seconds: number) {
  return new Promise(resolve => setTimeout(resolve, seconds, true));
}

function retryLoad(loader: () => Promise<any>, times: number) {
  if (times >= 3) {
    notification.warning({ description: '资源加载失败!' });
    Modal.confirm({
      message: '资源加载失败',
      description: '资源加载失败，是否刷新浏览器?',
      okText: '确认',
      cancelText: '取消',
      onOk: () => globalThis.location.reload(),
      onCancel: () => globalThis.location.reload(),
    });
    return Promise.resolve({ default: null });
  }

  return loader().catch(e => {
    console.error(e);
    return timePromise(1000).then(() => retryLoad(loader, times + 1));
  });
}

export default function LoadCmp(loader: () => Promise<any>) {
  const otherComponent = React.lazy(() => {
    return retryLoad(loader, 0);
  });
  return (props: any) => (
    <React.Suspense fallback={<LoadingTip />}>
      {React.createElement(otherComponent, {...props})}
    </React.Suspense>
  );
}
